if (!customElements.get('reserve-widget')) {
    customElements.define(
      'reserve-widget',
      class ReserveWidget extends HTMLElement {
        constructor() {
          super();

          this.elements = {
            formattedExpiredDate: this.querySelector('#formatted-expired-date'),
            formattedEndDate: this.querySelector('#formatted-end-date'),
            formattedUpcomingDate: this.querySelector('#formatted-upcoming-date'),
            daysRemaining: this.querySelector('#days-remaining'),
            dayLabel: this.querySelector('#day-label'),
            percentValue: this.querySelector('#percent-value'),
            progressFill: this.querySelector('#progress-fill'),
          };

          this.today = new Date();
          this.today.setHours(0, 0, 0, 0);

          this.msPerDay = 86400000;
          this.formattedExpiredDate = null;
          this.formattedEndDate = null;
          this.formattedUpcomingDate = null;
        }

        /*
         * Prepare dates and initialize the widget when it is connected to the DOM
         */
        connectedCallback() {
            this.init();
        }

        /*
         * Ordinal suffix function (1st, 2nd, 3rd, etc.)
         * @param {number} n - The number to get the ordinal suffix for
         * @returns {string} The ordinal suffix for the given number
         */
        getOrdinalSuffix(n) {
            const s = ["th", "st", "nd", "rd"];
            const v = n % 100;

            return n + (s[(v - 20) % 10] || s[v] || s[0]);
        }

        /*
         * Format date as "MONTH DAYth"
         * @param {Date} date - The date to format
         * @returns {string} The formatted date
         */
        formatDate(date) {
            const month = date.toLocaleString('en-US', { month: 'long' }); // e.g., AUGUST
            const day = date.getDate();
            return `${month} ${this.getOrdinalSuffix(day)}`; // e.g., AUGUST 8TH
        }

        /*
         * Parse date to local midnight
         * @param {string} str - The date to parse
         * @returns {Date} The parsed date
         */
        parseDateToLocalMidnight(str) {
            // assumes "YYYY-MM-DD" or ISO string
            const d = new Date(str);
            d.setHours(0,0,0,0);

            return d;
        }

        /*
         * Calculate days remaining and elapsed
         * @returns {object} The days remaining and elapsed and current percent
         */
        calculateDaysRemainingAndElapsed() {
            const daysRemaining = Math.max(0, Math.ceil((this.endDate - this.today) / this.msPerDay));
            const daysElapsed = Math.max(0, Math.floor((this.today - this.startDate) / this.msPerDay));
            const currentPercent = Math.min(100, this.startPercent + (this.increment * daysElapsed));

            return { daysRemaining, daysElapsed, currentPercent };
        }

        /*
         * Prepare dates
         */
        prepareDates() {
            const lastDayOfPreviousMonth = new Date(this.today.getFullYear(), this.today.getMonth(), 0);
            const firstDayOfNextMonth = new Date(this.today.getFullYear(), this.today.getMonth() + 1, 1);
            const tomorrow = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() + 1);

            this.formattedEndDate = this.formatDate(tomorrow);

            if (!this.autoUpdateDate) { return; }

            this.formattedExpiredDate = this.formatDate(lastDayOfPreviousMonth);
            this.formattedUpcomingDate = this.formatDate(firstDayOfNextMonth);
        }

        /*
         * Update the progress
         */
        updateProgress() {
            const { daysRemaining, daysElapsed, currentPercent } = this.calculateDaysRemainingAndElapsed();

            // this.elements.daysRemaining && (this.elements.daysRemaining.textContent = daysRemaining);
            // this.elements.dayLabel && (this.elements.dayLabel.textContent = daysRemaining > 1 ? 'days' : 'day');
            this.elements.percentValue && (this.elements.percentValue.textContent = currentPercent + '%');
            this.elements.progressFill && (this.elements.progressFill.style.width = currentPercent + '%');
        }

        /*
         * Update the expired and upcoming dates
         */
        updateExpiredAndUpcomingDates() {
            if (!this.autoUpdateDate) return;

            if (this.formattedExpiredDate && this.elements.formattedExpiredDate) {
                this.elements.formattedExpiredDate.textContent = this.formattedExpiredDate;
            }

            if (this.formattedUpcomingDate && this.elements.formattedUpcomingDate) {
                this.elements.formattedUpcomingDate.textContent = this.formattedUpcomingDate;
            }
        }

        /*
         * Update the current end date
         */
        updateCurrentEndDate() {
            if (this.formattedEndDate && this.elements.formattedEndDate) {
                this.elements.formattedEndDate.textContent = this.formattedEndDate;
            }
        }

        /*
         * Initialize the widget
         */
        init() {
            this.prepareDates();
            this.updateProgress();
            this.updateCurrentEndDate();
            this.updateExpiredAndUpcomingDates();
        }

        get increment() {
            return parseInt(this.getAttribute('increment'));
        }
        get startPercent() {
            return parseInt(this.getAttribute('start-percent')) || 10;
        }
        get endDate() {
            return this.parseDateToLocalMidnight(this.getAttribute('end-date'));
        }
        get startDate() {
            return this.parseDateToLocalMidnight(this.getAttribute('start-date'));
        }

        /*
         * Get auto update (expired and upcoming dates)
         * @returns {boolean} True if auto update date is enabled, false otherwise
         */
        get autoUpdateDate() {
            return this.getAttribute('auto-update-date') === 'true';
        }
      }
    );
  }
  